// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-popup-header {
    background-color: var(--bs-color);
    border-color: var(--bs-color);
    padding: 0.7rem !important;
    font-size: 1rem;
    color: var(--bs-header-font-color);
}`, "",{"version":3,"sources":["webpack://./src/components/info-popup.scss"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,0BAA0B;IAC1B,eAAe;IACf,kCAAkC;AACtC","sourcesContent":[".info-popup-header {\r\n    background-color: var(--bs-color);\r\n    border-color: var(--bs-color);\r\n    padding: 0.7rem !important;\r\n    font-size: 1rem;\r\n    color: var(--bs-header-font-color);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
